/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_PATH } from '@app/modules/common/enum-constant';
import {
    ApprovalInfo,
    CascadingDropdownOption,
    SubmitResponse,
    Survey,
    SurveyResponse,
    SurveySubmitData,
} from '@app/modules/common/survey-force-model';
import { map, Observable } from 'rxjs';
import { SurveyForceStoreService } from './survey-force-store.service';
import { environment } from '@environment/environment';

@Injectable()
export class AuthenService {
    private _surveyPath = APP_PATH.SURVEY_API;

    constructor(
        private _httpClient: HttpClient,
        private _sfService: SurveyForceStoreService
    ) {}

    public getSurveySubmitPath = (uuid: string): string =>
        `${environment.domain.svf.surveyUrl}${this._surveyPath}/survey?uuid=${uuid}`;

    public getSurvey(): Observable<SurveyResponse<Survey>> {
        const { uuid, is_banner, message_id, user_id, anonymous_id } =
            this._sfService.getAppData();
        return this._httpClient
            .get<SurveyResponse<Survey>>(
                `${environment.domain.svf.surveyUrl}${this._surveyPath}/survey`,
                {
                    params: {
                        uuid,
                        isBanner: is_banner,
                        merchantCode: user_id || '',
                        anonymousId: anonymous_id || '',
                        messageId: message_id || '',
                    },
                }
            )
            .pipe(map((res: SurveyResponse<Survey>) => res));
    }

    public submitSurvey(
        requestParams: SurveySubmitData
    ): Observable<SurveyResponse<SubmitResponse>> {
        const { uuid, ...params } = requestParams;
        return this._httpClient.post<SurveyResponse<SubmitResponse>>(
            this.getSurveySubmitPath(uuid),
            params
        );
    }

    public getApprovalInfo(): Observable<ApprovalInfo> {
        const { taker_id, reviewer_id } = this._sfService.getAppData();
        return this._httpClient
            .get<ApprovalInfo>(
                `${environment.domain.svf.surveyUrl}${this._surveyPath}/approval`,
                {
                    params: {
                        taker_id,
                        user_id: reviewer_id,
                    },
                }
            )
            .pipe(map((res: ApprovalInfo) => res));
    }

    public submitApproval(params: {
        value: 'Approved' | 'Rejected';
        is_cdm_edit_survey: boolean;
        message?: string;
    }): Observable<ApprovalInfo> {
        const { taker_id, reviewer_id } = this._sfService.getAppData();
        const extraData = this._sfService.getExtraData();
        return this._httpClient.post<ApprovalInfo>(
            `${environment.domain.svf.surveyUrl}${this._surveyPath}/approval?taker_id=${taker_id}`,
            {
                status: params.value,
                message: params.message || '',
                user_id: reviewer_id || '',
                extra_data: extraData || '',
                is_cdm_edit_survey: params.is_cdm_edit_survey || false,
            }
        );
    }

    public getCascadingOptions(
        parentId,
        questionId
    ): Observable<SurveyResponse<CascadingDropdownOption>> {
        const { uuid, is_banner, message_id, user_id, anonymous_id } =
            this._sfService.getAppData();
        return this._httpClient
            .get<SurveyResponse<CascadingDropdownOption>>(
                `${environment.domain.svf.surveyUrl}${this._surveyPath}/cascading`,
                {
                    params: {
                        questionId,
                        parentId,
                        ingt_name: 'Survey_Force_Flutter',
                    },
                }
            )
            .pipe(map((res: SurveyResponse<CascadingDropdownOption>) => res));
    }
}
